import React from 'react';

import { Popup } from './Popup';
import { PopupHeader } from './PopupHeader';
import { PopupContent } from './PopupContent';
import { PopupActions } from './PopupActions';
import { DownloadMessage } from './DownloadMessage';
import { InfoSection } from './InfoSection';

interface DownloadConfirmationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onDownloadAgain?: () => void;
  customerName?: string;
  accountCSN?: string;
  generatedBy?: string;
  downloadUrl?: string;
}

export const DownloadConfirmationPopup: React.FC<DownloadConfirmationPopupProps> = ({
  isOpen,
  onClose,
  onDownloadAgain,
  customerName,
  accountCSN,
  generatedBy,
  downloadUrl
}) => {
  return (
    <Popup isOpen={isOpen} onClose={onClose}>
      <PopupHeader title="Downloading configuration file" />
      
      <PopupContent>
        <DownloadMessage onDownloadAgain={onDownloadAgain} downloadUrl={downloadUrl} />
        <InfoSection 
          generatedBy={generatedBy}
          customerName={customerName}
          accountCSN={accountCSN}
        />
      </PopupContent>
      
      <PopupActions onClose={onClose} />
    </Popup>
  );
};

